import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { formFocusNextKeyboard } from 'shouldve-been-react';
import { QuickNumberInput } from 'shouldve-been-mui';

class IntegerChecklistElement extends ChecklistElement {

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number) {

        super(elementId, name, itemNumber, sortNumber, EditorType.INTEGER);
    }

    public buildFormElement(value: string, onBlur: (value: string) => Promise<void>, screenWidth: number): JSX.Element {

        return (
            <React.Fragment key={this.elementId}>
                <QuickNumberInput
                    value={value}
                    onBlur={onBlur}
                    variant='outlined'
                    dense={true}
                    minWidth={Math.min(screenWidth * 0.8, 500)}
                    maxWidth={Math.min(screenWidth * 0.8, 500)}
                    labelText={this.name}
                    height='40px'
                    onKeyDown={formFocusNextKeyboard}
                    allowDecimals={false}
                    minValue={null}
                    maxValue={null}
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default IntegerChecklistElement;